import { AprDetails } from 'src/hooks/earn/types';
import { EarnProduct } from 'src/hooks/useEarnProduct';

export const getEarnProductData = (
	earnProduct: EarnProduct | null,
	marketAprBreakdowns: AprDetails[]
) => {
	if (!earnProduct) return null;

	const baseSourceTitle = (() => {
		switch (earnProduct.productType) {
			case 'insurance_fund_vaults':
				return 'Insurance Fund APY';
			case 'borrow_lend':
				return 'Lending APY';
			default:
				return '';
		}
	})();

	const relevantBreakdowns = marketAprBreakdowns.filter((apr: AprDetails) => {
		if (earnProduct.productType === 'insurance_fund_vaults') {
			return apr.type === 'if-reward';
		}
		if (earnProduct.productType === 'borrow_lend') {
			return apr.type === 'lend-reward';
		}
		return false;
	});

	const isInsuranceFund = earnProduct.productType === 'insurance_fund_vaults';
	const baseApyData = {
		type: isInsuranceFund ? ('if' as const) : ('lend' as const),
		source: isInsuranceFund ? 'Insurance Fund' : 'Lending',
		apy: isInsuranceFund
			? (earnProduct.ifApy ?? 0)
			: (earnProduct.lendApy ?? 0),
	};

	return {
		baseSourceTitle,
		relevantBreakdowns,
		baseApyType: baseApyData.type,
		baseApySource: baseApyData.source,
		baseApy: baseApyData.apy,
	};
};
